<template>
    <div>
        <figure class="tourFigure">
            <div v-if="!showInfo">
                <img :src="getImageSrc(currentTour.card)">
                <div class="gradient-box"></div>
                <div class="line-item">
                    <div class="left-item" style="    position: fixed;">
                        <md-button title="Back to Tours" class="md-icon-button" @click="returnToPrevious" aria-label="Back">
                            <md-icon>arrow_back</md-icon>
                        </md-button>
                    </div>
                    <div class="left-item" style="    position: fixed;
    margin-left: 3%;">
                        <h3 class="link" @click="toggleInfoBlock('EDITOPEN')">{{ currentTour.name }}</h3>
                    </div>
                    <div class="right-item">
                        <md-menu class="tourSettings">
                            <md-button md-menu-trigger class="md-icon-button">
                                <md-icon>more_vert</md-icon>
                            </md-button>
                            <md-menu-content width="3">
                                <md-menu-item>
                                    <button class="md-button" @click="exportCurrentTour(currentTour.id)">Export Tour</button>
                                </md-menu-item>
                                <md-menu-item>
                                    <button class="md-button" @click="toggleShowSettings(true)">Tour Settings</button>
                                </md-menu-item>
                            </md-menu-content>
                        </md-menu>
                    </div>
                </div>
            </div>
            <div class="info-block" v-if="showInfo">
                <h3>
                    <textarea maxlength="60" rows="1" v-model="currentTour.name" placeholder="Tour Name"></textarea>
                </h3>
                <p>
                    <textarea maxlength="200" v-model="currentTour.description" placeholder="Description"></textarea>
                </p>
                <md-button class="md-icon-button close-info" @click="toggleInfoBlock('EDITCLOSE')">
                    <md-icon>close</md-icon>
                </md-button>
                <md-button class="save-button md-raised md-primary" @click="saveTourDetails">Save</md-button>
            </div>
        </figure>
        <md-dialog :md-active.sync="checkTarballComplet" style="overflow-y: scroll;">
            <md-list class="full-control">
                <p>
                    Your tour is still incomplete to make tarball. So complete your tour and export tarball.
                </p>
                <md-button class="ManualBtn ManualBtncancel" @click="closeCheckTarballComplet()">Close</md-button>
            </md-list>
        </md-dialog>
    </div>
</template>
<script>
import {saveTour, checkExportTours} from '../../services/EditorService.js';
import {mapGetters, mapActions} from 'vuex';

export default {
  data: () => ({
    showInfo: false,
    checkTarballComplet: false,
    editTourName: '',
    editTourDes: ''
  }),
  computed: {
    ...mapGetters('client', ['currentClient']),
    ...mapGetters('tours', ['currentTour'])
  },
  methods: {
    ...mapActions('editor', ['toggleShowSettings']),
    ...mapActions('tours', ['exportTours']),
    getImageSrc (image) {
      if (image) {
        if (image.substring(0, 5) !== 'https') {
          return 'static/img/dev/' + image;
        } else {
          return image;
        }
      } else {
        return 'static/img/dev/default-tour.png';
      }
    },
    toggleInfoBlock (editOpenClose) {
      if (editOpenClose === 'EDITOPEN') {
        this.editTourName = this.currentTour.name;
        this.editTourDes = this.currentTour.description;
      }
      if (editOpenClose === 'EDITCLOSE') {
        this.currentTour.name = this.editTourName;
        this.currentTour.description = this.editTourDes;
      }
      this.showInfo = !this.showInfo;
    },
    returnToPrevious () {
      this.$router.push('/client/tours');
    },
    saveTourDetails () {
      if (this.currentTour.name.length >= 1 && this.currentTour.description.length >= 1) {
        saveTour(this.currentTour);
        this.toggleInfoBlock('SAVECLOSE');
      }
    },
    closeCheckTarballComplet () {
      this.checkTarballComplet = false;
    },
    exportCurrentTour (tourId) {
      let self = this;
      checkExportTours(tourId).then(function (defs) {
        if (defs.data[0].activeInactiveImages === 0) {
          self.checkTarballComplet = true;
        } else {
          self.exportTours({tourIds: [tourId], clientId: self.currentClient.id});
        }
      });
    }
  },
  mounted () {
    this.toggleShowSettings(false);
  }
};
</script>
<style lang="scss">
.tourFigure .info-block h3 {
    padding: 0 0 8px !important;
}

.tourFigure .info-block p {
    padding: 0 !important;
}
.info-block h3 textarea::placeholder{
  color:darkgray;
  font-size: 16px;
}
.info-block p textarea::placeholder{
  color:darkgray;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/tour/TourFigure.vue